import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { I18n } from "aws-amplify/utils";
import { useEffect, useState } from "react";
import AlertPopup from "./alertPopup";

const MoveNodeModal = ({ open, onClose, nodes, onMoveNode, selectedNode }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [filteredNodes, setFilteredNodes] = useState(nodes);

  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");

  const filterNodes = (nodes, searchQuery) => {
    if (!searchQuery || searchQuery.trim() === "") return nodes;

    const query = searchQuery.toLowerCase();

    return nodes.filter((node) =>
      Object.entries(node).some(([key, value]) => {
        if (typeof value === "string" || typeof value === "number") {
          return String(value).toLowerCase().includes(query);
        }
        return false;
      })
    );
  };

  useEffect(() => {
    const filtered = filterNodes(nodes, searchQuery)?.filter(
      (node) => node.id !== selectedNode?.id
    ); //escludo il nodo click destro dalla lista dei genitori possibili
    setFilteredNodes(filtered);
  }, [searchQuery, nodes, selectedNode]);

  const columns = [
    { field: "id", headerName: "ID", width: "200" },
    { field: "name", headerName: "Name", width: "200" },
    { field: "job_family", headerName: "Job Family", width: "200" },
    { field: "job_function", headerName: "Job function", width: "200" },
    { field: "role", headerName: "Role", width: "200" },
    { field: "department", headerName: "Department", width: "200" },
  ];

  const showAlert = (message, severity) => {
    setAlertTitle(severity);
    setAlertMessage(message);
    setOpenAlert(true);
    // setTimeout(() => {
    //   setOpenAlert(false);
    // }, 3000);
  };
  const handleClose = () => {
    onClose();
    setSearchQuery("");
  };
  const handleConfirmMove = () => {
    if (selectedRow == null || !selectedNode) {
      showAlert(
        I18n.get("Please, select a node"),
        I18n.get("Node selection needed")
      );
      return;
    }
    if (selectedNode.parentId == null) {
      showAlert(
        I18n.get("The root node cannot be moved. Please select a different node."),
        I18n.get(
          "Action not allowed"
        )
      );
      console.log("parent id null");
      return;
    }
    const newParentId = selectedRow.id;
    const nodeId = selectedNode.id;

    onMoveNode(nodeId, newParentId);
    setSelectedRow(null);
    onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="90%"
        sx={{
          // "& .MuiDialog-paper": { width: "100%", maxWidth: "none" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiDialog-paper": {
            borderRadius: "1rem",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "24px" }} align="center">
          {" "}
          {I18n.get("Move node")}{" "}
        </DialogTitle>
        <DialogContent>
          <Stack
            display={"flex"}
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Box>
              <Typography variant="h4">
                {I18n.get("Available nodes")} ({filteredNodes?.length})
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "end",
              }}
            >
              <TextField
                label="Search"
                variant="standard"
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{
                  "& .MuiInputBase-input": {
                    padding: "12px 0px  12px  12px  ",
                  },
                  "& .MuiFormControl-root-MuiTextField-root": {
                    marginTop: "0px",
                  },
                  maxWidth: "200px",
                  mb: 2,
                }}
              />
            </Box>
          </Stack>
          <DataGrid
            rows={filteredNodes}
            columns={columns}
            disableMultipleRowSelection
            pagination
            onRowClick={(params) => setSelectedRow(params.row)}
            sx={{
              maxHeight: "400px",
              minWidth: "600px",
              // "& .MuiDataGrid-root, & .MuiDataGrid-footerContainer": {
              //   minHeight: "2rem",
              // },
              "&  .MuiDataGrid-cell ": {
                cursor: "default",
              },
              minHeight: "20vh",
              flexFlow: 1,
              height: "100%",
              mb: 2,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            {I18n.get("Close")}
          </Button>
          <Button
            onClick={handleConfirmMove}
            // disabled={!selectedNode}
            variant="contained"
            sx={{
              backgroundColor: "#344767",
              color: "rgb(255, 255, 255)",
              "&:hover": {
                backgroundColor: "rgb(40, 55, 80)",
              },
              "&:focus:not(:hover)": {
                backgroundColor: "#344767",
                boxShadow: "none",
              },
            }}
          >
            {I18n.get("Confirm")}
          </Button>
        </DialogActions>
      </Dialog>
      <AlertPopup
        open={openAlert}
        onClose={() => setOpenAlert(false)}
        alertTitle={alertTitle}
        alertMessage={alertMessage}
      />
    </>
  );
};
export default MoveNodeModal;
